const lb = angular.module('app.lb', []);
lb.run(['$rootScope', '$state', 'AUTH_EVENTS', ($rootScope, $state, AUTH_EVENTS) =>
  $rootScope.$on(AUTH_EVENTS.logoutSuccess, function () {
    const IsFromAuth0 = JSON.parse(sessionStorage.getItem('IsFromAuth0'));
    const loginPageSignIn = JSON.parse(sessionStorage.getItem('loginPageSignIn'));
    const NeedsFederatedLogout = JSON.parse(sessionStorage.getItem('NeedsFederatedLogout'));
    
    sessionStorage.removeItem('IsFromAuth0');
    sessionStorage.removeItem('loginPageSignIn');
    sessionStorage.removeItem('NeedsFederatedLogout');

    if (loginPageSignIn) return $state.go('landing.login');
    
    if (IsFromAuth0) {
      let returnTo = encodeURIComponent(`${window.location.origin}/#/logged-out`);
      let logoutUri = `?returnTo=${returnTo}&client_id=${window.Auth0ClientId}${NeedsFederatedLogout ? '&federated' : ''}`;
      window.location.href = `https://${window.Auth0Domain}/v2/logout${logoutUri}`;
    } else {
      if ($state.current.name !== 'landing.login') $state.go('loggedout');
    }
  })
]);

export default lb;



// WEBPACK FOOTER //
// ./src/appSpecificImports/index.lb.js